import request from "./request";

const galleryService = {
  upload: (data: any) => request.post(`/dashboard/galleries`, data),
  uploadMany: (data: any) =>
    request.post("dashboard/galleries/store-many", data),
};

export default galleryService;
